<button
    class="action-icon action-icon-primary relative"
    [appTooltip]="title | translate"
    [disabled]="isDisabled"
    (click)="onClick()"
    type="button"
>
    <i
        class="fa-light"
        [class.text-emerald-500]="isDone !== undefined && isDone"
        [class.text-amber-500]="isDone !== undefined && !isDone"
        [ngClass]="icon"
    ></i>
    @if (progress !== undefined && progress !== null) {
        <span
            class="absolute bottom-full left-1/2 -translate-x-1/2 translate-y-1/2 transform whitespace-nowrap rounded-md bg-emerald-500 px-1 py-0.5 text-xs font-bold text-white shadow"
        >
            {{ progress }}%
        </span>
    }
    @if (count !== undefined && count !== null && count > 0) {
        <span
            class="absolute -end-1.5 -top-1.5 flex h-4 w-4 items-center justify-center whitespace-nowrap rounded-full bg-emerald-500 text-xs font-bold text-white shadow"
        >
            {{ count }}
        </span>
    }
</button>
